/**
 * Detects non-actionable Safari ReferenceError noise where the browser's
 * internal video-controls code references an undefined `EmptyRanges` variable.
 *
 * Safari's native `<video>` controls implementation internally uses an
 * `EmptyRanges` variable (a `TimeRanges` placeholder) that occasionally fails
 * to resolve, producing a `ReferenceError: Can't find variable: EmptyRanges`
 * from functions like `played`, `buffered`, `syncControl`, and `handleEvent`.
 * All stack frames point to `undefined` source locations since the code lives
 * inside Safari's media-controls shadow DOM — there is nothing actionable in
 * application code.
 */
export const isSafariMediaEmptyRangesNoise = (
  message: string | undefined,
  stack: string | undefined,
): boolean => {
  if (!message) {
    return false;
  }

  if (message !== "Can't find variable: EmptyRanges") {
    return false;
  }

  if (!stack) {
    return true;
  }

  const frames = stack.split("\n").filter((l) => l.trim().startsWith("at "));

  if (frames.length === 0) {
    return true;
  }

  return frames.every((frame) => frame.includes("@ undefined"));
};
